import { Assets } from './Assets';

export const BasicIllustrationStyles = {
  fonts: `
        @font-face {
            font-family: 'Arial Narrow';
            src: local('Arial Narrow');
        }
        @font-face {
            font-family: 'Arial Narrow';
            font-weight: bold;
            src: local('Arial Narrow');
        }
        @font-face {
            font-family: 'Arial Narrow';
            font-style: italic;
            src: local('Arial Narrow');
        }
        @font-face {
            font-family: 'Arial Narrow';
            font-weight: bold;
            font-style: italic;
            src: local('Arial Narrow');
        }
        @font-face {
            font-family: 'Times New Roman';
            src: local('Times New Roman');
        }
        @font-face {
            font-family: 'Times New Roman';
            font-weight: bold;
            src: local('Times New Roman');
        }
        @font-face {
            font-family: 'Times New Roman';
            font-style: italic;
            src: local('Times New Roman');
        }
        @font-face {
            font-family: 'Times New Roman';
            font-weight: bold;
            font-style: italic;
            src: local('Times New Roman');
        }
        `,
  general: `body {margin-top: 0px;margin-left: 0px; font: 11px 'Times New Roman';line-height: 12px; letter-spacing: .2px; }
        .page-wrapper {width: 576px; max-width: 576px;}
        .full-width {width: 100%; max-width: 100%;}
        p {margin-top: 0px;margin-bottom: 0px; font: 11px 'Times New Roman';line-height: 12px; page-break-inside:avoid;}
        .content{font: 11px 'Times New Roman';line-height: 12px;}
        .content-cursive{font:italic 11px 'Times New Roman';line-height: 12px;}
        .content-bold{font:bold 11px 'Times New Roman';line-height: 12px;}
        .content-bold-large{font:bold 16px 'Times New Roman';line-height: 18px;}
        .content-bold-cursive{font:bold italic 11px 'Times New Roman';line-height: 12px;}
        .content-bold-underline{font:bold 11px 'Times New Roman';text-decoration: underline;line-height: 12px;}
        .wider-content{width: 66%;}
        .clr {clear:both;float:none;height:4px;margin:0px;padding:0px;overflow:hidden;}
        h1 {font:bold 18px 'Arial Narrow';margin:0}
        h2 {font:bold 12px 'Arial Narrow';line-height: 25px; margin:0 }
        .sub-heading{font:bold 11px 'Arial Narrow';line-height: 14px;margin-top:5px}
        .sub-heading-center{font:bold 10px 'Arial Narrow';line-height: 14px;margin-top:5px}
        .sub-heading-underline{font:bold 11px 'Arial Narrow';text-decoration: underline;line-height: 12px;margin-top:5px}
        .inline-header-cursive{font:bold italic 11px 'Arial Narrow';line-height: 12px;}
        .p-right{text-align: right;}
        .p-left{text-align: left;}
        .p-center{text-align: center;}
        .margin-bottom-5{margin-bottom:5px}
        .margin-bottom-10{margin-bottom:10px}
        .margin-bottom-15{margin-bottom:15px}
        .margin-top-10{margin-top:10px}
        .margin-top-20{margin-top:20px}
        .margin-top-40{margin-top:40px}
        .no-break {page-break-inside:avoid}
        .break-before {page-break-before:always}
        .supplemental-break-after {page-break-after:always}
        .left-indent {text-indent:3%}
        .illustration-header-row { text-align: right; }
        #illus-summary-table tr:nth-last-child(3) td:nth-last-of-type(-n + 2) {text-decoration: underline;}
        .supplemental-illustration-input-summary-break {border: none;background-color: #000;color: #000;height: 1px;margin-bottom: 5px;margin-top:5px}
        .smaller-text {font-size:10px}
        .gray-bg-with-border {border: 1px solid black; background-color: #D3D3D3;}
        `,
};
